import { Box, Chip, Popover, Typography } from '@mui/material'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import { useState } from 'react'
import OptionsFilter from '@/components/features/config/columns/Filter/OptionsFilter'
import { useAppTheme } from '@/theme/ThemeContext'

const NodeSelectMany = ({
  options,
  option2SelectedId,
  setOption2SelectedId,
  disabled = false,
}: {
  options: any
  option2SelectedId: string[]
  setOption2SelectedId: (id: string[]) => void
  disabled?: boolean
}) => {
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'

  const colors = {
    text: isDarkMode ? '#FFFFFF' : '#003F61',
    border: isDarkMode ? '#445876' : 'black',
    chipBg: isDarkMode ? '#374151' : '#E3F5FF',
    chipText: isDarkMode ? '#FFFFFF' : '#003F61',
    iconColor: isDarkMode ? '#FFFFFF' : 'black',
    bg: isDarkMode ? '#0D192F' : 'transparent',
  }

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
    setOpen(true)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setOpen(false)
  }
  const handleChange = (values: string[]) => {
    setOption2SelectedId(values)
  }
  return (
    <>
      {/* nodrag: same trigger pattern as NodeSelect — the popover renders in a
       * portal outside the node, so the opt-out belongs on the trigger. */}
      <Box
        className="nodrag"
        sx={{
          border: `1px solid ${colors.border}`,
          padding: '5px',
          display: 'flex',
          // alignItems: 'center',
          justifyContent: 'space-between',
          zIndex: 999990,
          cursor: disabled ? 'default' : 'pointer',
          width: '230px',
          maxWidth: '230px',
          opacity: disabled ? 0.5 : 1,
          backgroundColor: colors.bg,
        }}
        onClick={disabled ? undefined : handleOpen}
      >
        {open ? (
          <ArrowDropUpIcon sx={{ color: colors.iconColor }} />
        ) : (
          <ArrowDropDownIcon sx={{ color: colors.iconColor }} />
        )}

        {/* nowheel: this chip list scrolls once enough values are picked —
         * without it the wheel zooms the canvas instead of scrolling the list. */}
        <Box
          className="nowheel"
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            overflow: 'auto',
            maxHeight: '200px',
            gap: 1,
            direction: 'rtl',
            '&::-webkit-scrollbar': {
              width: '8px',
            },
            '&::-webkit-scrollbar-track': {
              background: isDarkMode ? '#202B40' : '#E4E7EB',
              borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb': {
              background: isDarkMode ? '#374151' : '#C1C7CD',
              borderRadius: '4px',
              transition: 'background 0.3s ease',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              background: isDarkMode ? '#4B5563' : '#A0A6AD',
            },
          }}
        >
          {option2SelectedId.length > 0 ? (
            option2SelectedId.map(id => {
              const option = options.find((option: any) => option.id === id)
              return (
                <Chip
                  key={id}
                  label={option?.label ?? id}
                  sx={{
                    backgroundColor: colors.chipBg,
                    color: colors.chipText,
                  }}
                />
              )
            })
          ) : (
            <Typography
              sx={{
                color: colors.text,
                textAlign: 'right',
                textOverflow: 'ellipsis',
                fontFamily: 'Rubik, sans-serif',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 300,
                lineHeight: '100%',
              }}
            >
              ערכים
            </Typography>
          )}
        </Box>
      </Box>
      <Popover
        open={open && !disabled}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <OptionsFilter
          selected={option2SelectedId}
          checkBox={false}
          options={options}
          onChange={handleChange}
        />
      </Popover>
    </>
  )
}

export default NodeSelectMany
